import api from '../api-methods'

const proxyStatic = process.env.VUE_APP_ENV === 'local' ? '/proxy_static' : process.env.VUE_APP_STATIC
const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API
const staticApi = {
	// 学校补全
	universityComplete: payload => {
		return api.get(proxyStatic + '/v2/university_auto_completions', payload)
	},
	// 城市补全
	cityComplete: payload => {
		return api.get(proxyStatic + '/v1/city_auto_completions', payload)
	},
	// 专业补全
	majorComplete: payload => {
		return api.get(proxyStatic + '/v1/major_auto_completions', payload)
	},
	// 学院补全
	unischoolComplete: payload => {
		return api.get(proxyStatic + '/v1/college_auto_completions', payload)
	},
	// 公司品牌混搜名称补全
	companyComplete: payload => {
		return api.get(proxyStatic + '/v1/brand_company_auto_completions', payload)
	},
	// 职位名称补全
	positionComplete: payload => {
		return api.get(proxyStatic + '/v1/job_title_auto_completions', payload)
	},
	// 职位名称补全（求职意向）
	positionCompleteIntention: payload => {
		return api.get(proxyStatic + '/v2/profession_auto_completions', payload)
	},
	// 其他技能补全
	skillComplete: payload => {
		return api.get(proxyStatic + '/v1/skill_auto_completions', payload)
	},
	// 获取公司详情
	getCompanyDetail: (companyToken, payload) => {
		return api.get(proxyStatic + `/v2/companies/${ companyToken }`, payload)
	},
	// 获取行业列表
	getIndustriesList: (companyToken, payload) => {
		return api.get(proxyStatic + `/v1/industries/list`, payload)
	},
	// 获取行业列表
	getProfessionsList: (companyToken, payload) => {
		return api.get(proxyStatic + `/v1/professions/hot_name?`, payload)
	},
	// 获取行业列表-一二三级
	getProfessionsTree: () => {
		return api.get(proxyStatic + `/v2/professions/tree`)
	},
	//根据关键字来搜索公司
	getSearchCompany: (payload)=>{
		return api.get(proxyStatic + `/v1/mixed_companies/augment`, payload)
	},
	//获取公司内推数职位数
	getCompanyNum: (payload)=>{
		return api.get(proxyApi + `/v3/companies/jobs_count`, payload)
	},
	//获取学校tag
	getSchoolTags: (id)=>{
		return api.get(proxyStatic + `/v2/universities/${id}/university_tags`)
	},
	getPrivacyInfoData: (payload) => {
		return api.get(proxyApi + '/v3/privacy_info', payload)
	}
}

export default staticApi
